import {API} from 'aws-amplify'
import {GQLQueryHelper} from 'urban-living-utils'

class QueryHelper {
  static #instance

  constructor(config) {
    if (QueryHelper.#instance) {
      throw new Error('Query Helper is a singleton')
    }

    if (!config) {
      throw new Error('config is required to instantiate QueryHelper')
    }

    API.configure(config)
    QueryHelper.#instance = this

    const clientProxy = {
      query: obj => API.graphql(obj),
      mutate: obj => API.graphql({query: obj.mutation, variables: obj.variables}),
    }
    GQLQueryHelper.init(() => clientProxy)
  }

  /**
   * @param {string} mutation
   * @param {*} params
   * @returns {Promise<*>}
   */
  async executeMutation(mutation, params) {
    return GQLQueryHelper.Instance().executeMutation(mutation, params)
  }

  /**
   * @param {string} query
   * @param {*?} params
   * @returns {Promise<*>}
   */
  async queryOnce(query, params) {
    return GQLQueryHelper.Instance().queryOnce(query, params)
  }

  /**
   * @param {string} query
   * @param {*?} params
   * @param {function?} listPayloadExtractor
   * @returns {GQLQueryIterator}
   */
  iterativeQuery(query, params, listPayloadExtractor) {
    return GQLQueryHelper.Instance().iterativeQuery(query, params, listPayloadExtractor)
  }

  /**
   * Will exhaustively search all records until we've gathered maximumResults, executed maximumIterations, or scanned all records
   * @param {string} query
   * @param {*?} params
   * @param {function?} listPayloadExtractor
   * @returns {Promise<Array<*>>}
   */
  async queryAll(query, params, listPayloadExtractor) {
    return GQLQueryHelper.Instance().queryAll(query, params, {listPayloadExtractor})
  }

  // ---------------------------------------------------------------
  // STATIC FUNCTIONS:

  /**
   * @param {*?} config
   * @returns {QueryHelper}
   */
  static Instance(config) {
    if (!QueryHelper.#instance) {
      QueryHelper.#instance = new QueryHelper(config)
    }
    return QueryHelper.#instance
  }
}

export default QueryHelper
